import type { TLocalityTypes } from 'utils/constants.ts';
import { getSeoName } from 'utils/tokenize';

export type ResponseLocalityData = {
	address: string;
	address_id: number;
	advert_locality_id: number | undefined;
	citypart: string;
	country_id: number;
	district: string;
	district_id: number;
	district_seo_name: string;
	entity_id: number;
	entity_type: TLocalityTypes; // todo: make turn this back to string if shit hits the fan or remove this comment
	housenumber: string;
	municipality: string;
	municipality_id: number;
	municipality_seo_name: string;
	quarter: string;
	quarter_id: number;
	region: string;
	region_id: number;
	region_seo_name: string;
	source: string;
	street: string;
	street_id: number;
	streetnumber: string;
	ward: string;
	ward_id: number;
	zip: string;
};

export type LocalityData = {
	address: string;
	addressId: number;
	offerLocalityId?: number;
	citypart: string;
	countryId: number;
	district: string;
	districtId: number;
	districtSeoName: string;
	entityId: number;
	entityType: TLocalityTypes; // todo: make turn this back to string if shit hits the fan or remove this comment
	housenumber: string;
	municipality: string;
	municipalityId: number;
	municipalitySeoName: string;
	quarter: string;
	quarterId: number;
	quarterSeoName: string;
	region: string;
	regionId: number;
	regionSeoName: string;
	source: string;
	street: string;
	streetId: number;
	streetnumber: string;
	ward: string;
	wardId: number;
	wardSeoName: string;
	zip: string;
};

export function normalizeLocality(locality: ResponseLocalityData): LocalityData {
	return {
		address: locality.address,
		addressId: locality.address_id,
		offerLocalityId: locality.advert_locality_id,
		citypart: locality.citypart,
		countryId: locality.country_id,
		district: locality.district,
		districtId: locality.district_id,
		districtSeoName: locality.district_seo_name,
		entityId: locality.entity_id,
		entityType: locality.entity_type,
		housenumber: locality.housenumber,
		municipality: locality.municipality,
		municipalityId: locality.municipality_id,
		municipalitySeoName: locality.municipality_seo_name,
		quarter: locality.quarter,
		quarterId: locality.quarter_id,
		quarterSeoName: getSeoName(locality.quarter),
		region: locality.region,
		regionId: locality.region_id,
		regionSeoName: locality.region_seo_name,
		source: locality.source,
		street: locality.street,
		streetId: locality.street_id,
		streetnumber: locality.streetnumber,
		ward: locality.ward,
		wardId: locality.ward_id,
		wardSeoName: getSeoName(locality.ward),
		zip: locality.zip,
	};
}

export function denormalizeLocality(locality: LocalityData): ResponseLocalityData {
	return {
		address: locality.address,
		address_id: locality.addressId,
		advert_locality_id: locality.offerLocalityId,
		citypart: locality.citypart,
		country_id: locality.countryId,
		district: locality.district,
		district_id: locality.districtId,
		district_seo_name: locality.districtSeoName,
		entity_id: locality.entityId,
		entity_type: locality.entityType,
		housenumber: locality.housenumber,
		municipality: locality.municipality,
		municipality_id: locality.municipalityId,
		municipality_seo_name: locality.municipalitySeoName,
		quarter: locality.quarter,
		quarter_id: locality.quarterId,
		region: locality.region,
		region_id: locality.regionId,
		region_seo_name: locality.regionSeoName,
		source: locality.source,
		street: locality.street,
		street_id: locality.streetId,
		streetnumber: locality.streetnumber,
		ward: locality.ward,
		ward_id: locality.wardId,
		zip: locality.zip,
	};
}

export type ResponseLocalitySuggestionData = {
	entity_id: number;
	entity_type: TLocalityTypes;
	seo_name: string;
	suggest_first_row: string;
	suggest_second_row: string;
};

export type LocalitySuggestionData = {
	entityId: number;
	entityType: TLocalityTypes;
	seoName: string;
	suggestFirstRow: string;
	suggestSecondRow: string;
	showDeleteButton?: boolean;
	radius?: number;
};

export function normalizeLocalitySuggestion(locality: ResponseLocalitySuggestionData): LocalitySuggestionData {
	return {
		entityId: locality.entity_id,
		entityType: locality.entity_type,
		seoName: locality.seo_name,
		suggestFirstRow: locality.suggest_first_row,
		suggestSecondRow: locality.suggest_second_row,
	};
}
